import cn from 'classnames'

const PROGRESS_GREEN = 'bg-green-500'
const PROGRESS_YELLOW = 'bg-yellow-500'
const PROGRESS_RED = 'bg-red-500'

export const renderProgressBar = (numClaimed, maxClaimable) => {
    numClaimed = numClaimed ? numClaimed : 0
    return maxClaimable !== null &&
        maxClaimable > 0 &&
        maxClaimable != numClaimed ? (
        <div>
            <div className="absolute bottom-0 z-99 w-full h-2 bg-black" />
            <div
                className={cn(
                    'absolute bottom-0 left-0 z-100 h-1',
                    numClaimed === 0
                        ? `w-[100%] ${PROGRESS_GREEN}`
                        : (maxClaimable - numClaimed) / maxClaimable > 0.95
                        ? `w-[95%] ${PROGRESS_GREEN}`
                        : (maxClaimable - numClaimed) / maxClaimable > 0.9
                        ? `w-[90%] ${PROGRESS_GREEN}`
                        : (maxClaimable - numClaimed) / maxClaimable > 0.85
                        ? `w-[85%] ${PROGRESS_GREEN}`
                        : (maxClaimable - numClaimed) / maxClaimable > 0.8
                        ? `w-[80%] ${PROGRESS_GREEN}`
                        : (maxClaimable - numClaimed) / maxClaimable > 0.75
                        ? `w-[75%] ${PROGRESS_GREEN}`
                        : (maxClaimable - numClaimed) / maxClaimable > 0.7
                        ? `w-[70%] ${PROGRESS_GREEN}`
                        : (maxClaimable - numClaimed) / maxClaimable > 0.65
                        ? `w-[65%] ${PROGRESS_GREEN}`
                        : (maxClaimable - numClaimed) / maxClaimable > 0.6
                        ? `w-[60%] ${PROGRESS_GREEN}`
                        : (maxClaimable - numClaimed) / maxClaimable > 0.55
                        ? `w-[55%] ${PROGRESS_GREEN}`
                        : (maxClaimable - numClaimed) / maxClaimable > 0.5
                        ? `w-[50%] ${PROGRESS_YELLOW}`
                        : (maxClaimable - numClaimed) / maxClaimable > 0.45
                        ? `w-[45%] ${PROGRESS_YELLOW}`
                        : (maxClaimable - numClaimed) / maxClaimable > 0.4
                        ? `w-[40%] ${PROGRESS_YELLOW}`
                        : (maxClaimable - numClaimed) / maxClaimable > 0.35
                        ? `w-[35%] ${PROGRESS_YELLOW}`
                        : (maxClaimable - numClaimed) / maxClaimable > 0.3
                        ? `w-[30%] ${PROGRESS_YELLOW}`
                        : (maxClaimable - numClaimed) / maxClaimable > 0.25
                        ? `w-[25%] animate-pulse ${PROGRESS_YELLOW}`
                        : (maxClaimable - numClaimed) / maxClaimable > 0.2
                        ? `w-[20%] animate-pulse ${PROGRESS_RED}`
                        : (maxClaimable - numClaimed) / maxClaimable > 0.15
                        ? `w-[15%] animate-pulse ${PROGRESS_RED}`
                        : (maxClaimable - numClaimed) / maxClaimable > 0.1
                        ? `w-[10%] animate-pulse ${PROGRESS_RED}`
                        : (maxClaimable - numClaimed) / maxClaimable > 0.05
                        ? `w-[5%] animate-pulse ${PROGRESS_RED}`
                        : (maxClaimable - numClaimed) / maxClaimable > 0
                        ? `w-[2%] animate-pulse ${PROGRESS_RED}`
                        : null,
                )}
            />
        </div>
    ) : null
}
